import LoadingModal from '@components/atoms/modals/LoadingModal';
import { useIsLoggedIn, useProfile } from '@hooks/api';
import { accountStatus } from '@models/api/user/profile/profile';
import Oops from '@pages/error/Oops';
import { Navigate } from 'react-router';

export type ProtectedRouteProps = {
    outlet: JSX.Element;
    accountStatus: accountStatus[];
};

export default function ProtectedRoute({
    outlet,
    accountStatus: allowedStatuses,
}: ProtectedRouteProps) {
    const isLoggedIn = useIsLoggedIn();
    const { data: userProfile, isLoading } = useProfile({
        enabled: isLoggedIn,
    });

    if (!isLoggedIn) {
        return <Navigate to={{ pathname: '/login' }} />;
    }

    if (isLoading) return <LoadingModal />;

    if (userProfile) {
        const status = userProfile.accountStatus?.name as
            | accountStatus
            | undefined;
        if (status && allowedStatuses.includes(status)) {
            return outlet;
        } else {
            return <Oops />;
        }
    } else {
        return <Navigate to={{ pathname: '/login' }} />;
    }
}
